import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css"; // Custom CSS for additional styling
import { faXmark, faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import NewPagination from "../DashBoard/NewPagination";
import { toTitleCase } from "../../Utils/helper";
import Confirmation_dialog from "../confirmation_dialog";

const RequestTable = ({
  data = [],
  columns = [],
  requestTypes = [],
  onApprove,
  onReject,
  isLoading = false,
  title = "Request Management",
  filter,
  page,
  totalPage,
  onPageChange,
  startIndex,
  endIndex,
  totalData,
  selectedType,
  setSelectedType
}) => {
  // State for filters
  const [searchTerm, setSearchTerm] = useState("");
  const confirmDialogInitialState = {
    show: false,
    title: "",
    message: "",
    confirmText: "",
    cancelText: "",
    isConfirm: false,
    isDenied: false,
    data: "",
    onSuccess: () => { }
  };
  const [showConfirmDialog, setShowConfirmDialog] = useState(
    confirmDialogInitialState
  );

  const handleConfirmDialogOpen = (message, confirmText, cancelText, data, onConfirm) => {
    setShowConfirmDialog((state) => ({
      ...state,
      show: true,
      message: toTitleCase(message),
      confirmText: confirmText,
      cancelText: cancelText,
      data: data,
      onSuccess: onConfirm
    }));
  };

  const handleConfirmDialogClose = () => {
    setShowConfirmDialog(confirmDialogInitialState);
  };
  return (
    <div className="request-table-container">
      <div className="card shadow-sm">
        <div className="card-header text-white d-flex justify-content-between align-items-center">
          <h5 className="mb-0">{title}</h5>
          <div className="d-flex gap-2">
            {/* Request Type Filter */}
            {filter.isFilterDropDownShow && <select
              className="form-select form-select-sm"
              value={selectedType}
              onChange={(e) => setSelectedType(e.target.value)}
              style={{ width: "180px" }}
            >
              <option value="">All Request Types</option>
              {requestTypes.map((item) => (
                <option key={item.value} value={item.value}>
                  {item.option}
                </option>
              ))}
            </select>}


            {/* Search Box */}
            {/* {filter.isFilterSearchShow &&  <div
              className="input-group input-group-sm"
              style={{ width: "200px" }}
            >
              <input
                type="text"
                className="form-control"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
} */}
          </div>
        </div>

        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-bordered mb-0">
              <thead className="table-light">
                <tr>
                  {columns.map((column) => (
                    <th
                      key={column.field}
                      style={{ width: column.width || "auto" }}
                      className="text-center"
                    >
                      {column.headerName}
                    </th>
                  ))}
                  <th style={{ width: "150px" }} className="text-center">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.length > 0 ? (
                  data.map((row) => (
                    <tr key={row.id}>
                      {columns.map((column) => (
                        <td
                          key={`${row.id}-${column.field}`}
                          className="text-center"
                        >
                          {column.renderCell
                            ? column.renderCell(row)
                            : row[column.field] || "-"}
                        </td>
                      ))}
                      <td className="text-center">
                        <div className="d-flex gap-2 justify-content-center">
                          <button
                            className="btn btn-sm submit-btn"
                            onClick={() => {
                              handleConfirmDialogOpen(
                                "are you sure you want to Approve ?",
                                "Yes",
                                "Cancel",
                                "",
                                () => onApprove(row)
                              );
                            }}
                            // onClick={() => onApprove(row)}
                            title="Approve"
                          >
                            <FontAwesomeIcon
                              icon={faCheck}
                              style={{ color: "white" }}
                            />
                          </button>
                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => {
                              handleConfirmDialogOpen(
                                "are you sure you want to reject ?",
                                "Yes",
                                "Cancel",
                                "",
                                () => onReject(row)
                              );
                            }}
                            // onClick={() => onReject(row)}
                            title="Reject"
                          >
                            <FontAwesomeIcon
                              icon={faXmark}
                            />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={columns.length + 1}
                      className="text-center py-4 text-muted"
                    >
                      No Requests Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="pagination-info">
          {data.length > 0 && (
            <NewPagination
              currentPage={page}
              totalPages={totalPage}
              handlePageChange={onPageChange}
              startIndex={startIndex}
              endIndex={endIndex}
              totalData={totalData}
            />
          )}
        </div>
        <Confirmation_dialog
          show={showConfirmDialog.show}
          title={showConfirmDialog.title}
          message={showConfirmDialog.message}
          confirmText={showConfirmDialog.confirmText}
          cancelText={showConfirmDialog.cancelText}
          state={showConfirmDialog}
          onSuccess={showConfirmDialog.onSuccess}
          handleConfirmDialogClose={handleConfirmDialogClose}
        />
      </div>
    </div>
  );
};

export default React.memo(RequestTable);
